import React from 'react';

const DurationCell = ({ duration }) => <span>{duration} d</span>;

export default DurationCell;
